
class ChatClientState {
	constructor() {
		this.key = window.Server.ID == null ? "_" : (window.Server.ID+"_");
	}

	crmKey(k) {
		return this.key + k;
	}

	clearIfNotUser(user) {
		const u = this.getter("lastUser");
		if (u !== user) {
			this.data = null;
			this.ui = null;
			this.lastEvent = null;
		}
		this.setter("lastUser", user);
	}

	/**
	 * @return {boolean}
	 */
	get collapsed() {
		const v = localStorage.getItem(this.crmKey("collapsed"));
		if (v == null) return true;
		else return "true" === v;
	}

	/**
	 * @param {boolean} state
	 */
	set collapsed(state) {
		try {
			localStorage.setItem(this.crmKey("collapsed"), state ? "true" : "false");
		} catch (e) {
			console.log("Cannot store collapsed chat state");
		}
	}

	get currentChat() {
		return this.getter("chat");
	}

	set currentChat(chatId) {
		this.setter("chat", chatId);
	}

	get snap() {
		let s = this.getter("snap");
		if (s == null) s = "bottom";
		return s;
	}

	set snap(snap) {
		this.setter("snap", snap);
	}

	get top() {
		let val = this.lgetter("top");
		if (val == null) val = "25vh";
		return val;
	}

	set top(top) {
		this.lsetter("top", top);
	}

	get bottom() {
		let val = this.lgetter("bottom");
		if (val == null) val = "25vh";
		return val;
	}

	set bottom(bottom) {
		this.lsetter("bottom", bottom);
	}


	get ui() {
		return this.getter("ui");
	}

	set ui(name) {
		this.setter("ui", name);
		this.setter("data", null);	// every change of UI will result in data cache clearing
	}


	get data() {
		const d = this.getter("data");
		if (d == null) return null;
		return JSON.parse(d);
	}

	set data(d) {
		this.setter("data", d == null ? null : JSON.stringify(d));
	}

	setMsg(chatId, msg) {
		this.setter("msg_" + chatId, msg == null ? null : (msg.length === 0 ? null : msg));
	}

	getMsg(chatId) {
		const msg = this.getter("msg_" + chatId);
		if (msg == null) return "";
		return msg;
	}

	setUnseen(chatId, count) {
		this.setter("unseen_"+chatId, count == null ? null : count.toString());
	}

	getUnseen(chatId) {
		const count = this.getter("unseen_"+chatId);
		return count == null ? 0 : parseInt(count);
	}

	/**
	 * Total value
	 */
	set unseen(count) {
		this.setter("unseen", count == null ? null : count.toString());
	}

	get unseen() {
		let count = this.getter("unseen");
		if (count == null) count = 0;
		else count = parseInt(count);
		return count;
	}


	get lastEvent() {
		return this.getter("lastEvent");
	}


	set lastEvent(id) {
		this.setter("lastEvent", id);
	}

	getter(name) {
		return sessionStorage.getItem(this.crmKey(name));
	}

	setter(name, value) {
		try {
			if (value == null) sessionStorage.removeItem(this.crmKey(name));
			else sessionStorage.setItem(this.crmKey(name), value);
		} catch (e) {
			console.log("Cannot store "+name);
		}
	}

	lgetter(name) {
		return localStorage.getItem(this.crmKey(name));
	}

	lsetter(name, value) {
		try {
			if (value == null) localStorage.removeItem(this.crmKey(name));
			else localStorage.setItem(this.crmKey(name), value);
		} catch (e) {
			console.log("Cannot store "+name);
		}
	}
}

export const chatClientState = new ChatClientState();
